import React from "react";
import { Link } from "react-router";
import Seo from "components/shared/Seo";

export const McpSetup = () => (
    <>
        <Seo title="MCP Setup" />
        <div className="container my-3">
            <h1 className="text-center my-3">Connect AI Tools via MCP</h1>
            <ol>
                <li>
                    Open your <Link to="/account">Profile</Link>, go to{" "}
                    <strong>MCP Access Tokens</strong> and click{" "}
                    <strong>Generate new token</strong>. Copy it right away; it
                    is shown only once. Tokens last 30 days.
                </li>
                <li>
                    Paste it into your tool&apos;s MCP config as an{" "}
                    <code>Authorization: Bearer &lt;token&gt;</code> header:
                    <ul>
                        <li>
                            <strong>OpenClaw</strong>:{" "}
                            <code>
                                mcp.servers.wishliz.headers.Authorization
                            </code>
                        </li>
                        <li>
                            <strong>VS Code</strong>: the <code>headers</code>{" "}
                            of the wishliz server in{" "}
                            <code>.vscode/mcp.json</code>
                        </li>
                    </ul>
                </li>
                <li>
                    Test it by asking your tool to list your wishlist items.
                </li>
            </ol>
            <p>
                You can keep several tokens at once (one per tool). If a token
                or config file may have leaked,{" "}
                <strong>revoke it immediately</strong> from your Profile; it
                stops working on the next call.
            </p>
        </div>
    </>
);
